import(/* webpackMode: "eager" */ "/vercel/path0/src/app/resources/page.tsx");
